import { Outlet } from "react-router";
import { AuthScreenContainer } from "./AuthScreenContainer";

const AuthLayout = () => {
    return (
        <AuthScreenContainer>
            <Outlet />
        </AuthScreenContainer>
    );
};

export default AuthLayout;
